import { render, staticRenderFns } from "./workcard.vue?vue&type=template&id=71b3d6a9&scoped=true&"
import script from "./workcard.vue?vue&type=script&lang=js&"
export * from "./workcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b3d6a9",
  null
  
)

export default component.exports